const categories = [
  {
    id: "all",
    name: "All",
    description: "A collection of all activities and contributions"
  },
  {
    id: "community",
    name: "Community",
    description: "My work with tech communities, mentorship, and events"
  },
  {
    id: "content",
    name: "Content",
    description: "Educational posts, case studies, and public build logs"
  },
  {
    id: "open-source",
    name: "Open Source",
    description: "Contributions to projects and ecosystem improvements"
  },
  {
    id: "product-building",
    name: "Product Building",
    description: "Side projects, Product experiments, and prototypes"
  },
  {
    id: "learnings",
    name: "Learnings",
    description: "Research, self-development, and continuous skill growth"
  },
  {
    id: "other",
    name: "Other",
    description: "Miscellaneous activities"
  }
];

export default categories;
